import { deriveWebp } from '@/utils/deriveWebp';
import React from 'react';

type ResponsiveImageProps = {
  src?: string;
  alt?: string;
  webpSrc?: string;
  preferWebp?: boolean;
  ImgComponent?: React.ElementType<any>;
  imgProps?: React.ImgHTMLAttributes<HTMLImageElement>;
  dataCy?: string;
  PictureComponent?: React.ComponentType<React.ComponentPropsWithoutRef<'picture'>>;
  pictureProps?: React.HTMLAttributes<HTMLPictureElement>;
};

/**  Note: if you want styled-component support (adding custom styles) for \<picture\> or \<img\>,
 *     pass PictureComponent or ImgComponent props as needed
 * */

export const ResponsiveImage: React.FC<ResponsiveImageProps> = ({
  src,
  alt,
  webpSrc,
  preferWebp = true,
  ImgComponent,
  imgProps,
  dataCy,
  PictureComponent,
  pictureProps,
}) => {
  if (!src) return null;
  const candidateWebp = webpSrc || deriveWebp(src);

  const PictureTag: any = PictureComponent || 'picture';

  return (
    <PictureTag {...pictureProps}>
      {preferWebp && candidateWebp && <source type="image/webp" srcSet={candidateWebp} />}
      {ImgComponent ? (
        <ImgComponent src={src} alt={alt} {...imgProps} data-cy={dataCy} />
      ) : (
        <img src={src} alt={alt} {...imgProps} data-cy={dataCy} />
      )}
    </PictureTag>
  );
};

export default ResponsiveImage;
